const DisputeGetter = {
  disputes: (state) => state.disputes,
};

export default DisputeGetter;
